import ProfileComponents from '../../components/profile/profile';

export default function ProfilePage() {
	return <ProfileComponents title="Personal Information" displayName="Profile Settings" />;
}
